import {
  IconDefinition,
  IconName,
  IconPrefix,
} from '@fortawesome/fontawesome-common-types';

export const faCustomIcon = (
  name: string,
  width: number,
  height: number,
  path: string
): IconDefinition => {
  return {
    prefix: 'fac' as IconPrefix,
    iconName: name as IconName,
    icon: [width, height, [], '', path],
  };
};
